/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
import UnlockedBy from './UnlockedBy';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.achievement`;
export default class AchievementLevelUsers extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      achievementLevel
    } = this.attrs;
    const canViewAchievementUsers = app.forum.attribute('canViewAchievementUsers');
    const userCount = achievementLevel.userCount();
    const additionalUsersCount = achievementLevel.userCount() - achievementLevel.lastUsers().length;
    return m("div", {
      className: "AchievementLevelUsers"
    }, !!userCount ? [m("div", {
      className: "AchievementLevelUsers-header"
    }, m(UnlockedBy, {
      achievementLevel: achievementLevel
    })), canViewAchievementUsers && [m("div", {
      className: "AchievementLevelUsers-list"
    }, achievementLevel.lastUsers().map(user => m(Avatar, {
      user: user
    }))), !!additionalUsersCount && m("div", {
      className: "AchievementLevelUsers-footer"
    }, t(`${prfx}.show_all`, {
      count: additionalUsersCount
    }))]] : m("div", {
      className: "AchievementLevelUsers-placeholder"
    }, t(`${prfx}.be_the_first`)));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementLevelUsers', AchievementLevelUsers);